import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const BarChart = ({ data, options }) => {
  const defaultOptions = {
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'top',
        formatter: (value) => `${value}%`,
        color: '#000',
        font: {
          weight: 'bold',
          size: 12
        }
      }
    },
    ...options
  };

  return <Bar data={data} options={defaultOptions} />;
};

export default BarChart;
